// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"89760980","711":"26cd8b91","882":"9146e838"}[chunkId] + ".chunk.js";
};